export default __webpack_public_path__ + "static/media/Loader.e7b4e022.svg";